module.exports = __webpack_public_path__ + "static/media/photo70.254b9d51.jpg";